import React from "react";
import { Button, Intent } from "@blueprintjs/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

export interface MyTasksToggleProps {
  isActive: boolean;
  onToggle: (isActive: boolean) => void;
  disabled?: boolean;
}

export const MyTasksToggle: React.FC<MyTasksToggleProps> = ({
  isActive,
  onToggle,
  disabled = false,
}) => {
  const handleClick = () => {
    if (!disabled) {
      onToggle(!isActive);
    }
  };

  return (
    <Button
      className={`my-tasks-toggle ${isActive ? "my-tasks-toggle--active" : ""}`}
      intent={isActive ? Intent.PRIMARY : Intent.NONE}
      onClick={handleClick}
      disabled={disabled}
      icon={<FontAwesomeIcon icon={faUser} />}
      minimal={!isActive}
      small
    >
      My Tasks
    </Button>
  );
};

export default MyTasksToggle;
